<template lang="html">

  <footer class="footer ">

    <div class="row-between">
      <img src="/static/img/logo.svg" width="205" alt="Logo footer Dotia">
      <nav>
        <a target="_blank" href="https://www.sanvalero.es/politica-cookies">Política de Cookies | </a>
        <a target="_blank" href="https://www.sanvalero.es/aviso-legal">Aviso legal | </a>
        <a target="_blank" href="https://www.sanvalero.es/politica-privacidad">Política de
          privacidad</a>
      </nav>
      <div class="box-sepe">
        <a target="_blank" href="https://inaem.aragon.es/"><img src="/static/img/logos/INAEM.png" alt="INAEM"></img></a>
        <strong>Agencia de Colocación Nº 0200000002</strong>
      </div>
    </div>


  </footer>

</template>

<script lang="js">
export default {
  name: 'app-footer',
}
</script>

<style scoped>
.footer {}
</style>


// WEBPACK FOOTER //
// src/components/parts/footer.vue